import { Fragment, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import HomeComponent from "../component/app/home/Home.component";
import { useAuth } from "../context/Auth.context";
import DealershipComponent from "../component/app/admin/dealership/Dealership.component";
import { useAppContext } from "../context/App.context";

const HomePage = () => {
  const auth = useAuth();
  const app = useAppContext();
  const location = useLocation();
  const navigate = useNavigate();
  const hasCheckedRedirect = useRef(false);
  const initialLoadRef = useRef(true);

  // Redirect associate managers to group dashboard on initial login only
useEffect(() => {
  if (location.pathname !== "/") return;

  if (
    (auth?.user?.loggedInAs === "manager" ||
      auth?.user?.loggedInAs === "employee") &&
    auth?.user?.associateDetails?.length > 1
  ) {
    const showHome = location.state?.showHome;
    const hasNavigatedToHome =
      sessionStorage.getItem("navigatedToHome");

    if (showHome || hasNavigatedToHome === "true") {
      sessionStorage.removeItem("navigatedToHome");
      return;
    }

    const alreadyRedirected =
      sessionStorage.getItem("groupDashboardRedirected");

    if (!alreadyRedirected) {
      sessionStorage.setItem(
        "groupDashboardRedirected",
        "true"
      );
      navigate("/groupDashboard", { replace: true });
    }
  }
}, [auth?.user, location.pathname, location.state, navigate]);

  return (
    <Fragment>
      {auth?.user?.loggedInAs === "admin" ? (
        <DealershipComponent />
      ) : (
        <HomeComponent />
      )}
    </Fragment>
  );
};

export default HomePage;
